import { Fragment } from 'react';

import { NsExpander } from 'components/common/ns-expander/NsExpander';
import { NsAnchor } from 'components/common/ns-anchor/NsAnchor';
import { NsList } from 'components/common/ns-list/NsList';
import { NsCta } from 'components/common/ns-cta/NsCta';
import { NsCaveatLink } from 'components/common/ns-caveat-link/NsCaveatLink';
import { HELP_CONTACT_NUMBER } from 'config/app-config';
import { useDDSavingsAmount } from 'hooks/useDDSavingsAmount';

export const directDebitPromotionExpanderTestId =
  'directDebitPromotionExpanderTestId';

export const DirectDebitPromotionExpander = () => {
  const { savingsAmount, priceCapDate } = useDDSavingsAmount();

  return (
    <NsExpander
      heading="Prefer to pay without a Direct Debit?"
      testId={directDebitPromotionExpanderTestId}
    >
      <p>
        We believe that monthly{' '}
        <NsAnchor href="/help-and-support/bills-and-payments/setting-up-a-direct-debit">
          Direct Debit
        </NsAnchor>{' '}
        is the best way to pay for your energy. It&apos;s less work for you and
        makes it much easier for you to manage with your online account. You can
        also get energy with us if you have a prepayment meter or ask to be
        moved on to a prepayment meter.
      </p>
      <p>
        We can also set you up for paying when you get the bill. But remember,
        paying this way could mean...
      </p>
      <NsList>
        {[
          <Fragment key={0}>
            You miss out on our best prices and tariffs.
          </Fragment>,
          <Fragment key={1}>
            You spend up to <strong>{savingsAmount} more per year</strong> on
            your bill.{' '}
            <NsCaveatLink>
              Paying when you get the bill extra spend based on a dual fuel
              customer with an average consumption of 11,500 kWh for gas and
              2,700 kWh for single-rate electricity at {priceCapDate} energy
              price cap rates.
            </NsCaveatLink>
          </Fragment>,
          <Fragment key={2}>
            Less predictable and manageable payments.
          </Fragment>,
          <Fragment key={3}>
            Additional fees if you don&apos;t pay your bill on time.
          </Fragment>,
          <Fragment key={4}>
            Costs aren&apos;t spread evenly across the whole year with more
            expensive winter payments.
          </Fragment>
        ]}
      </NsList>
      <p>
        If you want to pay for your energy without a Direct Debit (paying when
        you get the bill) give us a quick call and we&apos;ll be happy to
        provide you a new quote over the phone. Lines open 9am-5pm
        Monday-Friday.{' '}
        <NsCaveatLink>
          We&apos;re open Monday-Friday, 9am-5pm. We may record calls to help
          improve our service to you.
        </NsCaveatLink>
      </p>
      <NsCta type="text" href={`tel:${HELP_CONTACT_NUMBER.GENERAL}`}>
        Call us on {HELP_CONTACT_NUMBER.GENERAL_LABEL}
      </NsCta>
    </NsExpander>
  );
};
